import React, { FunctionComponent, useEffect, useRef, useState } from 'react'
import styles from './Brief.module.sass'
import Album, { albumHeight } from '../../../../data-components/files/Album/Album'
import { FileData } from '../../../../../responses/files'
import Html from '../../../../etc/Html/Html'
import { motion } from 'framer-motion'
import clsx from 'clsx'
import { useMeasure } from 'react-use'
import { useRipple } from 'react-use-ripple/dist'
import ChevronDownIcon from 'files/chevron/down.svg'
import { Classes } from '../../../../../styles'
import QuillEditor from '../../../../etc/Editor/QuillEditor'
import { useDerivedState, useUpload } from '../../../../../utils/hooks'
import { CommentData } from '../../../../../responses/comments'
import Spacer from '../../../../etc/Spacer'

export const isBriefEmpty = (files: FileData[], description?: string | null): boolean => !description && files.length === 0

const foldHeight = parseInt(styles.foldHeight)

interface Props {
    className?: string,
    headerClassName?: string,
    description?: string | null,
    files: FileData[],
    text: string,
    edit?: boolean,
    onChange?: (data: CommentData) => void,
    onFileClick: (file: FileData) => void,
    onCancel?: () => void,
    projectInfo?: boolean
}

const Brief: FunctionComponent<Props> = props => {
    const [open, setOpen] = useState(false)
    const [contentRef, { height }] = useMeasure<HTMLDivElement>()
    const headerRef = useRef<HTMLDivElement>(null)
    const [description, setDescription] = useDerivedState(props.description)

    const upload = useUpload(props.files)
    const {set} = upload
    useRipple(headerRef)

    useEffect(() => {
        if(props.edit) {
            setOpen(true)
            setDescription(props.description)
            set(props.files)
        }
    }, [props.edit, setDescription, props.description, set, props.files])

    if (!props.edit && isBriefEmpty(props.files, props.description)) {
        return null
    }

    return <motion.div
        className={clsx(props.className, styles.brief, { [styles.open]: open })}
        initial={{ height: foldHeight }}
        animate={{
            height: open ? 'auto' : foldHeight,
            background: open ? 'white': 'inherit',
        }}
        exit={{height: 0}}
    >
        <div ref={headerRef} className={clsx(props.headerClassName, styles.header, Classes.f16b)} onClick={() => setOpen(!open)}>
            <ChevronDownIcon className={clsx(styles.icon, { [Classes.flip]: open })}/>
            <div>{props.text}</div>
            <Spacer/>
            {props.children}
        </div>
        {
            props.edit? <div className={styles.content}>
                <QuillEditor
                    className={styles.editor}
                    editMode
                    rightFiles
                    value={description}
                    onChange={setDescription}
                    onCancel={props.onCancel}
                    upload={upload}
                    onSend={props.onChange}
                />
            </div>:<div className={styles.content}>
                <Html ref={contentRef} className={styles.text} html={props.description}/>
                <Album
                    className={styles.files}
                    files={props.files}
                    lines={Math.floor(height / albumHeight) || 2}
                    onClick={props.onFileClick}
                    projectInfo={props.projectInfo ?? false}
                />
            </div>
        }
    </motion.div>
}

export default Brief